import { Component, ReactElement } from "react";
import { appContext } from "../../../../AppContext";
import { Card, Grid, Divider, Typography, Box, Skeleton } from "@mui/material";
import "../../../../styles/css/dashboard.scss";
import "./cateringOrder.scss";
import IbssButton from "../../../../Components/Buttons/Button/IbssButton";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import { Icons } from "../../../../Common/AllsvgIcons";
import { RouteComponentProps } from "react-router-dom";
import { DateTime } from "luxon";
import { ICostCodeAllocation } from "../../../../Providers.Api/Tasks/CreateTaskEndpoint";
import { INode, PagedResponse } from "../../../../Providers.Api/Models";
import { Modal } from "react-bootstrap";
import { Space } from "../../../../Providers.Api/Spaces/SpaceRepository";
import IbssHorizontalTabs, { TabsParameters } from "../../../../Components/Layout/Tabs/IbssTabs";
import { ICreateCateringOrder } from "../../../../Providers.Api/CateringOrders/CreateCateringOrderEndpoint";
import IbssDialog from "../../../../Components/Dialogs/BaseDialog/IbssDialog";
import IbssCheckBox from "../../../../Components/Inputs/CheckBox/IbssCheckBox";
import { Classification, Status } from "../../../../Providers.Api/CateringItems/CateringItemRepository";
import { IGetV2BookingResponse } from "../../../../Providers.Api/Bookings/GetV2BookingEndpoint";
import { ICateringOrderPolicy } from "../../../../Providers.Api/CateringOrderPolicies/CateringOrderPoliciesRepository";
import CostCodesDialog, { CostCodeWithAllocation } from "../../../../Components/Dialogs/CostCodesDialog/CostCodesDialog";
import { StaticContext } from "react-router";
import { CateringMenuStatus, Filter, IMenuItems } from "../../../../Providers.Api/CateringMenus/CateringMenuRepository";
import LoadingOverlay from "../../../../Components/Navigation/LoadingOverlay/LoadingOverlay";
import { ICateringMenu } from "../../../../Providers.Api/CateringMenus/GetByIdEndpoint";
import { IOperationalSettings, Weekday } from "./DataModels";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { DateHelper } from "../../../../Common/DateHelper";
import OrderSummaryWidget from "./OrderSummaryWidget";
import AddNewOrderWidget from "./AddNewOrderWidget";
import BookingDetailsWidget from "./BookingDetailsWidget";
import OrderSummaryPanel from "./OrderSummaryPanel";
import { BuildingParamater, CateringOrder, IMenuItem } from "./DataModels";
import UnsavedChangesPopup from "./UnsavedChangesPopup";
import { IDefaultCostCodes } from "../../../../Providers.Api/UserPreferences/UserPreferenceRepository";
import ConfirmModal from "../../../../Components/Dialogs/ConfirmDialog/ConfirmModal";
import { ICateringMenuExpanded } from "./DataModels";
import UpdateCateringStatusButtons from "./UpdateCateringStatusButtons";
import { CateringOrderStatus } from "../../../../Common/Enums";
import ChangeMenuPopup from "./ChangeMenuPopup";
import ConfirmChangesWithMenuPopup from "./ConfirmChangesWithMenuPopup";
import { rights } from "../../../../Common/RightsManager";
import IbssCateringItemsAccordion from "../../../../Components/Miscellaneous/CateringItemsAccordion/IbssCateringItemsAccordion";
import AlertModal from "../../../../Components/Dialogs/AlertDialog/AlertModal";
import Helper from "../../../../Common/Helper";
import { EmptyOperationalSettings } from "./DataModels";

export default class EditCateringOrder extends IbssPage<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private get apiClient() { return appContext().apiClient; }
    private get localStorage() { return appContext().localStorageProvider; }
    private get appState() { return appContext().state; }
    private get bookingService() { return appContext().bookingService; }
    private get apiCache() { return appContext().apiCache; }
    private buildingId: number;
    private buildingNode: INode | null;
    private hasMultipleOrdersRights: boolean;
    private isOneLens: boolean;
    private userCateringRights: boolean;
    private userAPICateringApproveRights: boolean;
    private userCateringCancelRights: boolean;
    private userIgnoreCateringCutOffRights: boolean;

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            originalOrder: new OrderView(),
            order: new OrderView(),
            allCateringOrdersForBooking: [],
            selectedOrderId: '',
            orderItems: [],
            loading: false,
            allOrderedItemsAvailable: true,
            currency: '',
            preBookCateringTime: '',
            showConfirmationModal: false,
            floorId: 0,
            spaceId: '',
            currentUsersRoleIds: [],
            numOfAttendees: 0,
            spaces: [],
            showCostCodeModal: false,
            lightModeTheme: this.appState.lightModeTheme,
            costCodes: [],
            menu: {
                menuId: '',
                name: '',
                operationalSettings: 
                {
                    Monday: { CateringCutOff: ''},
                    Tuesday: { CateringCutOff: ''},
                    Wednesday: { CateringCutOff: ''},
                    Thursday: { CateringCutOff: ''},
                    Friday: { CateringCutOff: ''},
                    Saturday: { CateringCutOff: ''},
                    Sunday: { CateringCutOff: ''},
                }
            },
            newMenuId: '',
            cateringRestrictions: [],
            selectedRestrictions: [],
            selectedRestrictionsEdit: [],
            showRestrictionsModal: false,
            selectedAllergenRestrictionsFilter: [],
            selectedAllergenRestrictionsFilterEdit: [],
            selectedDietaryRestrictionsFilterEdit: [],
            selectedDietaryRestrictionsFilter: [],
            showFilterModal: false,
            showRemoveItemsFromUnavailableMenuModal: false,
            itemOrderPolicies: [],
            skeletonLoad: false,
            showStatusUpdateConfirmation: '',
            resetCateringStatus: false,
            availableCateringMenusView: [],
            showCateringAddedPopup: false,
            showChangeMenuPopup: false,
            showChangeMenuPastCutoff: false,
            showConfirmChangesWithMenuPopup: false,
            bookingData: {} as IGetV2BookingResponse,
            orderPolicies: [],
            availableCateringMenus: [],
            ordersCateringMenus: [],
            unsavedChanges: false,
            showUnsavedChangesPopup: false,
            attemptedOrderIdToSelect: '',
            viewBookingSelected: false,
            showServiceTimeChangeWarning: false,
            dontShowServiceChangeWarningAgain: false,
            buildingAlwaysApproveCateringOrders: 0
        };
        this.buildingId = parseInt(this.props.match.params.buildingid);
        this.buildingNode = this.getSelectedBuildingNode(parseInt(this.props.match.params.buildingid))
        this.hasMultipleOrdersRights = rights.API.Catering.MultipleOrders.has(this.buildingId);
        this.isOneLens = window.location.href.includes('operational-services-catering');
        this.userCateringRights = rights.ONELENS360.OperationalServices.Catering.appliesTo().has(this.buildingId);
        this.userAPICateringApproveRights = rights.API.Catering.Approve.has(this.buildingId);
        this.userCateringCancelRights = rights.DATAMODEL.CateringOrders.Delete.has();
        this.userIgnoreCateringCutOffRights = rights.API.Catering.IgnoreCutOff.has(this.buildingId)
    }

    public async componentDidMount(): Promise<void>
    {
        if (!this.isOneLens)
        {
            this.pageTitle = this.labels.HubMenumySchedule;
        }
        else
        {
            this.pageTitle = `${this.labels.HubLabelFacilityManagement} - ${this.appState.buildingName}`;
        }
        
        this.appState.autoMap<IState>(this, i => ({ lightModeTheme: i.lightModeTheme }));
        const { match } = this.props;
        this.setState({ skeletonLoad: true });
        const spaces = await this.apiCache.getSpacesByBuilding(this.buildingId);
        const cateringOrdersForBooking = await this.getCateringOrdersForBooking();

        const buildingParams = await appContext().ibssApiClientV1.v1.byNodeid.parameters.get<BuildingParamater[]>({
            nodeId: this.buildingId,
            filter: `Node_Id eq ${this.buildingId} and Parameter_Name eq 'AlwaysApproveCateringOrders'`,
            select: BuildingParamater
        });

        let alwaysApproveCateringOrders = '0'

        if (buildingParams.length > 0)
        {
            alwaysApproveCateringOrders = buildingParams[0].Parameter_Value;
        }

        this.setState({ allCateringOrdersForBooking: cateringOrdersForBooking.value.map(x => OrderView.fromApiTask(x)), buildingAlwaysApproveCateringOrders: parseInt(alwaysApproveCateringOrders) });
        let orderData = cateringOrdersForBooking.value.length > 0 ? cateringOrdersForBooking.value[0] : null;
        if (match.params.cateringOrderId)
        {
            orderData = cateringOrdersForBooking.value.filter(x => x.Order_Id == match.params.cateringOrderId)[0]
        }
        this.setState({ selectedOrderId: orderData ? orderData.Order_Id : '' })
        const order = (orderData == null ? null : OrderView.fromApiTask(orderData));
        const floorId = order?.nodeId ?? spaces.filter(space => space.Space_Id == match.params.spaceId)[0].Node_Id;
        const bookingId = order?.bookingId ?? match.params.bookingid;
        let menuId = order?.menuItems[0]?.menuId ?? null;
        const bookingData = await this.bookingService.get(floorId, bookingId);
        const orderPolicy = await this.apiClient.cateringOrderPolicies.getMany(this.buildingId);
        this.setState({ bookingData: bookingData, orderPolicies: orderPolicy });
        let cateringMenu = null
        await this.getCateringMenusByMenuIds();

        if (order == null)
            {
                await this.setStateAsync({
                    order: new OrderView({
                        ...this.state.order,
                        cateringServiceTime: DateHelper.fromIsoByNode(bookingData.Booking_Start, bookingData.Node_Id),
                        cateringClearingTime: DateHelper.fromIsoByNode(bookingData.Booking_End, bookingData.Node_Id),
                    })
                });
            }
    
        if (order != null)
        {
            this.setState({
                order: order,
                originalOrder: order,
                selectedRestrictions: order.cateringOrderRestrictions,
            });
        }
        
        try
        {
            const currentUsersRoles = await this.apiClient.roles.getRolesByCurrentUser();

            await this.setStateAsync
            ({
                currentUsersRoleIds: currentUsersRoles?.map(role => role.id) ?? [],
            });    
            
            await this.getCateringMenus(order?.spaceId ?? bookingData.Space_Id);
            
            if(menuId)
            {
                // if menuId is not null => editing a cateringOrder. 
                cateringMenu = this.state.availableCateringMenus.find(menu => menu.Menu_Id == menuId ) ?? null;
            }
            else
            {
                // if menuId is null, user is creating new catering order. set catering menu to first in list of catering menus
                cateringMenu = this.state.availableCateringMenus[0] ?? null;
            }
        } 
        catch (error)
        {
            cateringMenu = null;
        }

        // If an existing order is being edited then get the menu that order was created against
        if (menuId != null && cateringMenu == null)
        {
            try
            {
                cateringMenu = await this.apiClient.cateringMenus.getById(this.buildingId, menuId, true, true);
            } catch (error)
            {
                cateringMenu = null;
            }
        }

        if (cateringMenu != null)
        {
            const menuView = MenuView.fromApiModel(cateringMenu, this.state.order, bookingData, orderPolicy, this.userCateringRights)

            this.setStateAsync({
                menu: menuView.menu,
                orderItems: menuView.orderItems,
            });

            if(this.showPastCateringCutoffPopup(menuView.menu.menuId))
            {
                // if menu loaded by default is past catering cutofftime and user does not have ignoreCutoff rights, show popup.
                this.setState({showChangeMenuPastCutoff: true});
            }
        }

        const cateringRestrictions = (await this.apiClient.cateringRestrictions.getCateringRestrictions(this.buildingId)).Value;
        const filteredCateringRestrictions = cateringRestrictions.filter(x => x.Section == 'Allergen' || x.Section == 'Dietary');

        this.setState({
            floorId: floorId,
            spaceId: order?.spaceId ?? bookingData.Space_Id,
            cateringRestrictions: filteredCateringRestrictions.map(x => ({ id: x.Restriction_Id ?? '', section: x.Section, imageURI: x.ImageURI, name: x.Name })),
            spaces: spaces
        });

        let selectedBuilding: INode | null = this.buildingNode;

        if (selectedBuilding == null)
        {
            return;
        }
        this.setState
        ({ 
            currency: selectedBuilding.Cat_Crncy, 
            preBookCateringTime: this.getPreBookCateringCutoff(selectedBuilding, this.state.menu.operationalSettings, this.state.order.cateringServiceTime)
        });

        await this.loadTaskCostCodes();
        if (this.props.history.location.pathname.includes('create-catering-order') && this.state.costCodes.length === 0)
        {
            // if catering task is being created and it has no cost codes assigned, try to get userPreference default catering cost codes
            await this.getDefaultCateringCostCodes();
        }

        if (cateringOrdersForBooking.value.length > 0)
        {
            this.checkMenuItemAvailability(this.state.selectedOrderId)
        }
        this.setState({ skeletonLoad: false });
    }

    private getSelectedBuildingNode(buildingId: number): INode | null
    {
        const availableSpaces = this.localStorage.getNodeData();
        const buildings = availableSpaces.Regions.map(x => x.Buildings);
        let selectedBuilding: INode | null = null;

        for (let i = 0; i < buildings.length; i++)
        {
            const building = buildings[i].filter(building => building.Node_Id === buildingId);
            if (building.length > 0)
            {
                selectedBuilding = building[0];
                break;
            }
        }

        return selectedBuilding;
    }

    private getPreBookCateringCutoff(selectedBuilding: INode | null, operationSettings: IOperationalSettings, serviceTime: DateTime): string
    {
        // if user has not defined cateringCutoff times in any of the 7 weekdays in operationSettings, use the building's pre booking catering cutoff time
        // if user has defined cateringCutoff time of the 7 weekdays in operationSettings and it matches the order's day, use that day's pre booking catering cutoff time, else use blank string.
        const cateringCutOffsIsUndefined = this.cateringCutOffsIsUndefined(operationSettings);
        if(cateringCutOffsIsUndefined)
        {
            return selectedBuilding?.Pre_Book_Cat_Time ?? '';
        }

        const dayOfTheWeek = serviceTime.weekdayLong;
        const cateringCutOffsDay = this.cateringCutOffsDay(operationSettings, dayOfTheWeek);
        if(cateringCutOffsDay)
        {
            return operationSettings[cateringCutOffsDay as Weekday].CateringCutOff;
        }
        else
        {
            return '';
        }
    }

    private cateringCutOffsIsUndefined(operationSettings: IOperationalSettings): boolean
    {
        return Object.keys(operationSettings).every((key)=> operationSettings[key as Weekday].CateringCutOff === '');
    }

    private cateringCutOffsDay(operationSettings: IOperationalSettings, dayOfTheWeek: string): string
    {
        return Object.keys(operationSettings).find((key)=> key === dayOfTheWeek && operationSettings[key as Weekday].CateringCutOff !== '') ?? '';
    }

    private checkMenuItemAvailability(selectedOrderId: string): void
    {
        const selectedOrderMenuItems = this.state.allCateringOrdersForBooking.find(order => order.orderId === selectedOrderId)?.menuItems || [];

        const menuItemDetails = this.state.ordersCateringMenus.flatMap(menu => menu.Menu_MenuItems)
            .map(menuItem => ({
                id: menuItem.MenuItem_Id,
                menuId: menuItem.Menu_Id
            }));
        const allItemsExist = selectedOrderMenuItems.every(selectedItem => menuItemDetails.some(menuItem => menuItem.id === selectedItem.id && menuItem.menuId === selectedItem.menuId));
        this.setState({ allOrderedItemsAvailable: allItemsExist });
    }
    private generateRoldIdsQuery(roleIds: string[]): string
    {
        const roleIdsQueryInternal = roleIds.map(roleId => `c/Role_Id eq '${roleId}'`).join(' or ');
        const roleIdsQuery = ` and Menu_Roles/any(c: ${roleIdsQueryInternal})`;
        return roleIdsQuery;
    }

    private async getCateringMenus(spaceId: string): Promise<void>
    {
        try
        {
            const roleIdsFilterQuery = this.state.currentUsersRoleIds.length > 0? this.generateRoldIdsQuery(this.state.currentUsersRoleIds): '';

            const cateringMenus = await appContext().ibssApiClientV2.v2.byNodeid.cateringMenu.get<PagedResponse<ICateringMenuExpanded[]>>
            ({
                nodeId: this.buildingId,
                recursive: true,
                top: 100,
                select: ICateringMenuExpanded,
                filter: `Status eq 'StatusActive' and Available_From le ${this.state.bookingData.Booking_Start} and Available_Until ge ${this.state.bookingData.Booking_End} and Menu_Spaces/any(Menu_Space: Menu_Space/Space_Id eq '${spaceId.split(';')[0]}')${roleIdsFilterQuery}`
            });

            this.setState({
                availableCateringMenusView: cateringMenus.value.map(menu => MenuView.fromApiModel(menu, null, this.state.bookingData, this.state.orderPolicies, this.userCateringRights)),
                availableCateringMenus: cateringMenus.value,
            });
        }
        catch
        {
            return;
        }
    }

    private generateMenuIdsQuery(menuIds: string[]): string
    {
        const menuIdsQuery = menuIds.map(menuId => `Menu_Id eq '${menuId}'`).join(' or ');
        return `(${menuIdsQuery})`;
    }

    private async getCateringMenusByMenuIds(): Promise<void>
    {
        try
        {
            const menuIds = this.state.allCateringOrdersForBooking.map(order => order.menuItems[0]?.menuId ?? '' );
            
            const menuIdsFilterQuery = menuIds.length > 0? this.generateMenuIdsQuery(menuIds): '';

            const cateringMenus = await appContext().ibssApiClientV2.v2.byNodeid.cateringMenu.get<PagedResponse<ICateringMenuExpanded[]>>
            ({
                nodeId: this.buildingId,
                recursive: true,
                top: 50,
                select: ICateringMenuExpanded,
                filter: `${menuIdsFilterQuery}`
            });

            this.setState({
                ordersCateringMenus: cateringMenus.value,
            });
        }
        catch
        {
            return;
        }
    }

    private changeCateringSpace = async(nodeId: number, spaceId: string, spaceName: string): Promise<void> =>
    {
        // confirm swap space button is pressed. update spaceId for all catering orders. cateringOrderMenus are not changed at this stage because user need to have option to use menu that is unavailable in space.
        const floorId = this.state.spaces.find(space => space.Space_Id === this.state.spaceId)?.Node_Id ?? 0;
        await this.setStateAsync({ order: new OrderView({ ...this.state.order, nodeId: nodeId, spaceId: spaceId, spaceName: spaceName }), resetCateringStatus: true, unsavedChanges: true, floorId: floorId, spaceId: spaceId });
        await this.updateSpacesForAllOrders();
        await this.getCateringMenus(spaceId);
    }

    private get cateringOrdersWithUnavailableMenu(): OrderView[]
    {
        // non-cancelled orders with menus that can'be be matched to menus on new space
        const cateringOrdersWithUnavailableMenu = this.state.allCateringOrdersForBooking.filter(cateringOrder => !this.cateringOrderIsCancelled(cateringOrder) && !this.state.availableCateringMenusView.find(menu=> menu.menu.menuId === cateringOrder.menuItems[0]?.menuId));
        return cateringOrdersWithUnavailableMenu;
    }

    private cateringOrderHasUnavailableMenu(cateringOrderId: string): boolean
    {
        return !!this.cateringOrdersWithUnavailableMenu.find(cateringOrder => cateringOrder.orderId === cateringOrderId);
    }

    private cateringOrderIsCancelled(cateringOrder: OrderView): boolean
    {
        return (cateringOrder.cateringStatus === 'CancelledNoCharge' ||  cateringOrder.cateringStatus === 'CancelledCharged');
    }

    private async getDefaultCateringCostCodes(): Promise<void>
    {
        const { DefaultCateringCostCodes } = this.localStorage.getUserPreferences();

        if (DefaultCateringCostCodes.length === 0)
        {
            //if theres no default catering cost code the cost codes associated to the booking should be applied
            if(this.state.bookingData.Cost_Code_Allocation != null)
            {
                const bookingCostCodes = this.state.bookingData.Cost_Code_Allocation.map(costCode => CostAllocationView.fromBookingCateringCostCodes(costCode));
                await this.setStateAsync({ costCodes: bookingCostCodes });
            }
        }
        else
        {
            const defaultCateringCostCodes = DefaultCateringCostCodes.map(costCode => CostAllocationView.fromUserPrefDefaultCateringCostCodes(costCode));
            await this.setStateAsync({ costCodes: defaultCateringCostCodes });
        }
    }

    private getCostCodeAllocationLabel(): string
    {
        // if there an no allocated cost codes to task AND there is no userPreference defaultCateringCostCode, label is 'Add +';
        return this.state.order.costCodeAllocation.length == 0 && this.state.costCodes.length === 0 ? 'Add +' : this.state.costCodes.map(x => x.costCode).join(', ');
    }

    private async getCateringOrdersForBooking(): Promise<PagedResponse<CateringOrder[]>>
    {
        const cateringOrdersForBooking = await appContext().ibssApiClientV2.v2.byNodeid.cateringOrder.get<PagedResponse<CateringOrder[]>>({
            nodeId: this.buildingId,
            filter: `Booking_Id eq '${this.props.match.params.bookingid}'`,
            recursive: true,
            top: 20,
            select: CateringOrder,
        });
        return cateringOrdersForBooking;
    }

    private setItemQuantity(itemId: string, newItemQuantity: number): void
    {
        const objIndex = this.state.orderItems.findIndex(x => x.menuItemId === itemId);
        const newOrderItems = this.state.orderItems;
        
        if (newItemQuantity < 0 || newItemQuantity > 1000)
        {
            return;
        }

        newOrderItems[objIndex].quantity = newItemQuantity;
        this.setState({ orderItems: newOrderItems, resetCateringStatus: true, unsavedChanges: true });
    }

    private itemQuantityInputChanged(itemId: string, input: string): void
    {
        const newItemQuantity = parseInt(input);
        this.setItemQuantity(itemId, newItemQuantity);
    }

    private async updateCateringOrderSpace(orderId: string, nodeId: number, orderStatus: string): Promise<void>
    {
        try
        {
            await appContext().ibssApiClientV2.v2.byNodeid.cateringOrder.byOrderId.patch<string>({
                nodeId: nodeId,
                orderId: orderId,
                body: 
                {
                    Catering_Order_Status:this.state.buildingAlwaysApproveCateringOrders == 1 || !this.state.resetCateringStatus ? CateringOrderStatus.Approved : CateringOrderStatus.PendingApproval,
                    Node_Id: this.state.floorId,
                    Space_Id: this.state.spaceId,
                }
            })
        } 
        catch (error)
        {
            return;
        }
    }

    private async updateSpacesForAllOrders(): Promise<void>
    {
        // update currently selected order
        await this.updateOrder();

        // update the space for all other orders
        const selectedOrderId = this.state.order.orderId;
        const otherOrders = this.state.allCateringOrdersForBooking.filter(order => order.orderId !== selectedOrderId);
        this.setState({ loading: true });


        const promises = otherOrders.map(order=> this.updateCateringOrderSpace(order.orderId, order.nodeId, order.cateringStatus));
        try
        {
            await Promise.all(promises);
        }
        catch
        {
            return;
        }
        finally
        {
            const cateringOrdersForBooking = await this.getCateringOrdersForBooking();
            const cateringOrdersForBookingView = cateringOrdersForBooking.value.map(x => OrderView.fromApiTask(x));
            const order = cateringOrdersForBookingView.filter(x => x.orderId == this.state.order.orderId)[0];
            
            this.setState({ 
                unsavedChanges: false, 
                allCateringOrdersForBooking: cateringOrdersForBookingView, 
                order: order,
                loading: false, 
                showConfirmationModal: false });
        }
    }

    private async updateOrder(): Promise<void>
    {
        this.setState({ loading: true })

        const orderTotal = this.state.orderItems?.map(x => x.retailPrice * x.quantity).reduce((x, y) => { return x + y }, 0).toFixed(2);

        const orderItems = this.state.orderItems
            .filter(item => item.quantity > 0).map(item => { return ({ Id: item.menuItemId, Menu_Id: this.state.menu.menuId, Description: item.description, QuantityOfItems: item.quantity }) });

        const costCodeAllocations = this.state.costCodes
            .map(i => ({ Cost_Code: i.costCode, Cost_Code_Id: i.costCodeId, Allocation: i.allocation }));

        const cateringCutoffTime = this.getPreBookCateringCutoff(
            this.buildingNode,
            this.state.menu.operationalSettings,
            this.state.order.cateringServiceTime
        );

        const bookingStart = DateHelper.fromIsoByNode(this.state.bookingData.Booking_Start, this.state.bookingData.Node_Id);
        const calculatedCateringCutoffTime  = this.getCutOffTime(cateringCutoffTime,bookingStart);

        const payload = this.state.order.toApiOrder(
            this.state.order.spaceId.split(';')[0],
            this.state.bookingData.Booking_Id,
            this.state.floorId,
            this.state.numOfAttendees,
            JSON.stringify(orderItems),
            costCodeAllocations,
            parseFloat(orderTotal),
            this.state.selectedRestrictions,
            this.state.order.cateringStatus != CateringOrderStatus.PendingApproval && (this.state.buildingAlwaysApproveCateringOrders == 1 || !this.state.resetCateringStatus) ? CateringOrderStatus.Approved : CateringOrderStatus.PendingApproval,
            this.state.order.cateringServiceTime.toUtcByNode(this.state.floorId).toISO(),
            this.state.order.cateringClearingTime.toUtcByNode(this.state.floorId).toISO(),
            calculatedCateringCutoffTime.toUtcByNode(this.state.floorId).toISO()
        );

        try
        {
            await this.apiClient.cateringOrders.editCateringOrder(this.state.floorId, this.state.order.orderId, payload);
            await this.updateOrderIsDisabled();
            const cateringOrdersForBooking = await this.getCateringOrdersForBooking();
            
            const allCateringOrdersForBooking = cateringOrdersForBooking.value.map(x => OrderView.fromApiTask(x));
            const order = allCateringOrdersForBooking.filter(x => x.orderId == this.state.order.orderId)[0];

            this.setState({ 
                unsavedChanges: false, 
                allCateringOrdersForBooking: allCateringOrdersForBooking, 
                order: order,
                loading: false, 
                showConfirmationModal: false 
            });

        } 
        catch (error)
        {
            this.setState({ loading: false })
        }
    }

    private async updateOrderAndCateringMenus(): Promise<void>
    {
        // updateOrder and then update catering menus used by orders.
        await this.updateOrder();
        this.setState({loading: true});
        await this.getCateringMenusByMenuIds();
        this.setState({loading: false});
    }

    private async enableOrder(): Promise<void>
    {
        try
        {
            await appContext().ibssApiClientV2.v2.byNodeid.cateringOrder.byOrderId.enable.patch<unknown>({
                nodeId: this.state.order.nodeId,
                orderId: this.state.order.orderId,
            });
        }
        catch
        {
            return;
        }
    }

    private async disableOrder(): Promise<void>
    {
        try
        {
            await appContext().ibssApiClientV2.v2.byNodeid.cateringOrder.byOrderId.disable.patch<unknown>({
                nodeId: this.state.order.nodeId,
                orderId: this.state.order.orderId,
            });
        }
        catch
        {
            return;
        }
    }
    private async updateOrderIsDisabled(): Promise<void>
    {
        if(this.state.order.isDisabled && !this.state.originalOrder.isDisabled)
        {
            await this.disableOrder();
        }
        else if(!this.state.order.isDisabled && this.state.originalOrder.isDisabled)
        {
            await this.enableOrder();
        }
    }

    private cancelChanges(): void
    {
        const { match } = this.props
        const activeurl = window.location.href;

        if (this.props.location.state?.originRoute)
        {
            this.props.history.push(this.props.location.state?.originRoute);
        }
        else if ((match.params.bookingid !== undefined || activeurl.includes("flex-my-bookings")) && !activeurl.includes('operational-services-catering'))
        {
            this.props.history.push(`/flex-my-bookings/${this.buildingId}/mybooking/${this.props.match.params.bookingid}/${this.state.bookingData.Space_Id}`);
        }
        else
        {
            this.props.history.push("/catering-orders/" + this.buildingId);
        }
    }

    private async create(): Promise<void>
    {
        const { match } = this.props
        this.setState({ loading: true });
        const orderTotal = this.state.orderItems?.map(x => x.retailPrice * x.quantity).reduce((x, y) => { return x + y }, 0).toFixed(2);
        const orderItems = this.state.orderItems
            .filter(item => item.quantity > 0).map(item => { return ({ Id: item.menuItemId, Menu_Id: this.state.menu.menuId, Description: item.description, QuantityOfItems: item.quantity }) });
        const costCodeAllocations = this.state.costCodes
            .map(i => ({ Cost_Code: i.costCode, Cost_Code_Id: i.costCodeId, Allocation: i.allocation }));
        const payload = this.state.order.toApiOrder(
            this.state.bookingData.Space_Id.split(';')[0],
            match.params.bookingid,
            this.state.floorId,
            this.state.numOfAttendees,
            JSON.stringify(orderItems),
            costCodeAllocations,
            parseFloat(orderTotal),
            this.state.selectedRestrictions,
            this.state.buildingAlwaysApproveCateringOrders == 1 ? CateringOrderStatus.Approved : CateringOrderStatus.PendingApproval,
            this.state.order.cateringServiceTime.toUtcByNode(this.state.floorId).toISO(),
            this.state.order.cateringClearingTime.toUtcByNode(this.state.floorId).toISO()
        );
        try
        {
            await this.apiClient.cateringOrders.createCateringOrder(this.state.floorId, payload);
            const cateringOrdersForBookingResponse = await this.getCateringOrdersForBooking();
            const cateringOrdersForBooking = cateringOrdersForBookingResponse.value;
            const newOrder = cateringOrdersForBooking.slice().pop();
            const order = newOrder? OrderView.fromApiTask(newOrder) : this.state.order;
            this.setState({ 
                unsavedChanges: false, 
                allCateringOrdersForBooking: cateringOrdersForBooking.map(x => OrderView.fromApiTask(x)), 
                showCateringAddedPopup: true,
                order: order,
                selectedOrderId: order.orderId,
                loading: false });
        } catch (error)
        {
            this.setState({ loading: false })
        }
    }

    private handleCostCodeModal(): void
    {
        this.setState((prevState) => ({
            showCostCodeModal: !prevState.showCostCodeModal
        }));
    }

    private async updateBookingCostCodes(updatedCostCodes: CostCodeWithAllocation[]): Promise<void>
    {
        this.setState((prevState) =>
        {
            return {
                ...prevState,
                costCodes: updatedCostCodes,
                loading: true
            }
        });
        let i = 0;
        while (this.state.allCateringOrdersForBooking.length > i)
        {
            try
            {
                await appContext().ibssApiClientV2.v2.byNodeid.cateringOrder.byOrderId.patch<string>({
                    nodeId: this.state.bookingData.Node_Id,
                    orderId: this.state.allCateringOrdersForBooking[i].orderId,
                    body: { Cost_Code_Allocation: JSON.stringify(updatedCostCodes.map(i => ({ Cost_Code: i.costCode, Cost_Code_Id: i.costCodeId, Allocation: i.allocation }))) }
                });
            } catch (error)
            {

            }
            i = i + 1;
        }

        this.setState({ loading: false });

    }

    private async loadTaskCostCodes(): Promise<void>
    {
        const taskCostCodes: ICostAllocation[] = this.state.order.costCodeAllocation ?? [];

        this.setState({
            costCodes: taskCostCodes, //costs codes associated with task, which has to be displayed on this component.
        });
    }

    public async handleChangeCateringServiceTime(date: Date | null): Promise<void>
    {
        if (date !== null)
        {
            const cateringServiceTime = DateTime.fromJSDate(date);
            await this.setStateAsync({ order: new OrderView({ ...this.state.order, cateringServiceTime: cateringServiceTime ?? '' }), resetCateringStatus: true, unsavedChanges: true });

            const cateringMenus = [...this.state.availableCateringMenus, ...this.state.ordersCateringMenus];
            const cateringMenu = cateringMenus.filter(menu => menu.Menu_Id == this.state.menu.menuId)[0];

            const menuView = MenuView.fromApiModel(cateringMenu, this.state.order, this.state.bookingData, this.state.orderPolicies, this.userCateringRights);

            this.setState({
                orderItems: this.state.orderItems.map(x => 
                {
                    const itemAvailable = menuView.orderItems.some(item => item.menuItemId == x.menuItemId && item.availableToOrder)
                    return (
                        { ...x, quantity: itemAvailable ? x.quantity : 0, availableToOrder: itemAvailable }
                    )
                }
                )
            });
        }
    }

    public handleChangeCateringClearingTime(date: Date | null): void
    {
        if (date !== null)
        {
            const cateringClearingTime = DateTime.fromJSDate(date);
            this.setState({ order: new OrderView({ ...this.state.order, cateringClearingTime: cateringClearingTime ?? '' }), resetCateringStatus: true, unsavedChanges: true });
        }
    }

    private restrictionCheckboxSelected(checked: boolean, restriction: ICateringRestrictionView): void
    {
        if (checked)
        {
            this.setState({ selectedRestrictionsEdit: [...this.state.selectedRestrictionsEdit, restriction] })
        }
        if (!checked)
        {
            const updatedItems = this.state.selectedRestrictionsEdit.filter(x => x.id !== restriction.id)
            this.setState({ selectedRestrictionsEdit: updatedItems })
        }
    }

    private displayRestrictionsModal(): void
    {
        this.setState({ showRestrictionsModal: true, selectedRestrictionsEdit: this.state.selectedRestrictions })
    }

    private closeRestrictionsModal(): void
    {
        this.setState({ showRestrictionsModal: false, selectedRestrictionsEdit: [] })
    }

    private applyRestrictionUpdated(): void
    {
        this.setState({ showRestrictionsModal: false, selectedRestrictions: this.state.selectedRestrictionsEdit, selectedRestrictionsEdit: [], unsavedChanges: true })
    }

    private displayFilterModal(): void
    {
        this.setState({ showFilterModal: true, selectedAllergenRestrictionsFilterEdit: this.state.selectedAllergenRestrictionsFilter, selectedDietaryRestrictionsFilterEdit: this.state.selectedDietaryRestrictionsFilter })
    }

    private closeFilterModal(): void
    {
        this.setState({ showFilterModal: false, selectedAllergenRestrictionsFilterEdit: [], selectedDietaryRestrictionsFilterEdit: [] })
    }

    private applyRestrictionFilterUpdated(): void
    {
        const updatedOrderItems = this.state.orderItems.map(x =>
        {
            const itemDietaryRestrictions = x.menuItemRestrictions.filter(restriction => restriction.section == 'Dietary');
            const itemAllergenRestrictions = x.menuItemRestrictions.filter(restriction => restriction.section == 'Allergen');

            let dietaryFilterRequirementsValid = true;
            for (let index = 0; index < this.state.selectedDietaryRestrictionsFilterEdit.length; index++)
            {
                if (this.state.selectedDietaryRestrictionsFilterEdit.length > 0 && !itemDietaryRestrictions.map(x => x.name).includes(this.state.selectedDietaryRestrictionsFilterEdit[index]))
                {
                    dietaryFilterRequirementsValid = false;
                }
            }
            if (this.state.selectedDietaryRestrictionsFilterEdit.length > 0 && itemDietaryRestrictions.length == 0)
            {
                dietaryFilterRequirementsValid = false;
            }

            let allergenRequirementsValid = true;
            for (let index = 0; index < itemAllergenRestrictions.length; index++)
            {
                if (this.state.selectedAllergenRestrictionsFilterEdit.length > 0 && this.state.selectedAllergenRestrictionsFilterEdit.includes(itemAllergenRestrictions[index].name))
                {
                    allergenRequirementsValid = false;
                }
            }

            return (
                {
                    ...x,
                    meetsFilterRequirements: dietaryFilterRequirementsValid && allergenRequirementsValid
                }
            )
        });
        this.setState({
            showFilterModal: false,
            selectedAllergenRestrictionsFilter: this.state.selectedAllergenRestrictionsFilterEdit,
            selectedAllergenRestrictionsFilterEdit: [],
            selectedDietaryRestrictionsFilter: this.state.selectedDietaryRestrictionsFilterEdit,
            selectedDietaryRestrictionsFilterEdit: [],
            orderItems: updatedOrderItems
        });
    }

    private allergenFilterCheckboxSelected(checked: boolean, restriction: string): void
    {

        if (checked)
        {
            this.setState({ selectedAllergenRestrictionsFilterEdit: [...this.state.selectedAllergenRestrictionsFilterEdit, restriction] })
        }
        if (!checked)
        {
            const updatedItems = this.state.selectedAllergenRestrictionsFilterEdit.filter(x => x !== restriction)
            this.setState({ selectedAllergenRestrictionsFilterEdit: updatedItems })
        }
    }

    private dietaryFilterCheckboxSelected(checked: boolean, restriction: string): void
    {

        if (checked)
        {
            this.setState({ selectedDietaryRestrictionsFilterEdit: [...this.state.selectedDietaryRestrictionsFilterEdit, restriction] })
        }
        if (!checked)
        {
            const updatedItems = this.state.selectedDietaryRestrictionsFilterEdit.filter(x => x !== restriction)
            this.setState({ selectedDietaryRestrictionsFilterEdit: updatedItems })
        }
    }

    private getClassificationLabel(classification: string): string
    {
        if (classification == 'MenuItemClassificationFood')
        {
            return this.labels.HubLabelFood
        }
        if (classification == 'MenuItemClassificationSnack')
        {
            return this.labels.HubLabelSnack
        }
        if (classification == 'MenuItemClassificationBeverage')
        {
            return this.labels.HubLabelBeverage
        }
        return '';
    }

    private async updateOrderStatus(status: string): Promise<void>
    {
        this.setState({ loading: true });
        try
        {
            await this.apiClient.cateringOrders.patchCateringOrder(this.state.order.nodeId, this.state.order.orderId, { Catering_Order_Status: status });
            const cateringOrdersForBooking = await this.getCateringOrdersForBooking();
            this.setState({
                allCateringOrdersForBooking: cateringOrdersForBooking.value.map(x => OrderView.fromApiTask(x)),
                order: cateringOrdersForBooking.value.map(x => OrderView.fromApiTask(x)).filter(x => x.orderId == this.state.order.orderId)[0],
                loading: false,
                showStatusUpdateConfirmation: ''
            });
        } catch (error)
        {
            this.setState({ loading: false, showStatusUpdateConfirmation: '' });
        }
    }

    private menuChanged(menuId: string): void
    {
        const selectedMenu = this.getAllMenusViewForOrder(menuId).filter(x => x.menu.menuId == menuId);

        const orderItems = selectedMenu[0].orderItems.map(item => ({ ...item, quantity: 0 }));
        const cateringMenus = [...this.state.availableCateringMenus, ...this.state.ordersCateringMenus]
        const cateringMenu = cateringMenus.filter(menu => menu.Menu_Id == menuId)[0];
        const menuView = MenuView.fromApiModel(cateringMenu, this.state.order, this.state.bookingData, this.state.orderPolicies, this.userCateringRights);

        this.setState({
            menu: selectedMenu[0].menu,
            orderItems: orderItems.map(x => 
                {
                    const itemAvailable = menuView.orderItems.some(item => item.menuItemId == x.menuItemId && item.availableToOrder)
                    return (
                        { ...x, availableToOrder: itemAvailable }
                    )
                }
                ),
            showChangeMenuPopup: false,
        });

        // when user first creates an order after booking (but not in order edit mode), allow users to change cateringCutoffTime when they select different menus
        const newOrder = !this.state.order.bookingId;
        if(newOrder)
        {
            const cateringCutoffTime = this.getPreBookCateringCutoff(this.buildingNode, selectedMenu[0].menu.operationalSettings, this.state.order.cateringServiceTime);
            this.setState({preBookCateringTime: cateringCutoffTime});
        }
    }

    private showPastCateringCutoffPopup(menuId: string): boolean
    {
        const selectedMenu = this.getAllMenusViewForOrder(menuId).filter(x => x.menu.menuId == menuId)[0];
        const bookingStart =  DateHelper.fromIsoByNode(this.state.bookingData.Booking_Start, this.state.bookingData.Node_Id);
        const cateringPreBookCutoff = this.getPreBookCateringCutoff(this.buildingNode, selectedMenu.menu.operationalSettings, this.state.order.cateringServiceTime);
        const cutOffTime = this.getCutOffTime(cateringPreBookCutoff, bookingStart)
        const pastCutOffPeriod = this.isPastCutoffPeriod(cutOffTime);

        const canIgnoreCutoffRestrictions = this.userIgnoreCateringCutOffRights;
        return (pastCutOffPeriod && !canIgnoreCutoffRestrictions);
    }

    private selectMenu(menuId: string): void
    {
        if(this.showPastCateringCutoffPopup(menuId))
        {
            // if newly selected menu is past catering cutofftime and user does not have ignoreCutoff rights, prevent user from selecting the menu by returning and stopping execution.
            this.setState({showChangeMenuPastCutoff: true});
            return;
        }

        if(this.state.orderItems.some(orderItem => orderItem.quantity > 0))
        {
            // only show popup if order contains items in positive quantities.
            this.setState({ newMenuId: menuId, showChangeMenuPopup: true });
        }
        else
        {
            this.setState({ newMenuId: menuId });
            this.menuChanged(menuId);
        }
    }

    private onViewBookingClicked(checkForUnsavedChanges: boolean): void
    {
        if(this.state.unsavedChanges && checkForUnsavedChanges)
        {
            this.setState({ showUnsavedChangesPopup: true, viewBookingSelected: true });
        }
        else
        {
            if (this.props.location.state?.originRoute)
            {
                this.props.history.push(this.props.location.state?.originRoute);
            }
            else
            {
                this.props.history.push(`/flex-my-bookings/${this.buildingId}/mybooking/${this.props.match.params.bookingid}/${this.state.bookingData.Space_Id}`);
            }
        }
    };

    private onReturnHomeClicked(): void
    {
        this.props.history.push("/flex-home");
    };

    private closeItemsFromUnavailableMenuModal(): void
    {
        this.setState({
            showRemoveItemsFromUnavailableMenuModal: false,
        });
    }

    private async orderSelected(orderId: string, skipUnsavedChangesCheck: boolean): Promise<void>
    {
        if(orderId === this.state.selectedOrderId)
        {
            if(this.cateringOrderHasUnavailableMenu(orderId))
            {
                this.setState({showRemoveItemsFromUnavailableMenuModal: true})
            }

            return;
        }

        if (this.state.unsavedChanges == true && skipUnsavedChangesCheck == false)
        {
            this.setState({ showUnsavedChangesPopup: true, attemptedOrderIdToSelect: orderId });
            return;
        }

        // if order's spaceId is not the same as this.state.spaceId, set spaceId to order's spaceId to get availableCateringMenus for order's space.
        const selectedOrder = this.state.allCateringOrdersForBooking.find(order => order.orderId === orderId);
        if(selectedOrder && selectedOrder.spaceId !== this.state.spaceId)
        {
            // set new space and new floor.
            const floorId = this.state.spaces.find(space => space.Space_Id === this.state.spaceId)?.Node_Id ?? 0;
            this.setState({floorId: floorId, spaceId: selectedOrder.spaceId});
            await this.getCateringMenus(selectedOrder.spaceId);
        }

        this.setState({ unsavedChanges: false, showUnsavedChangesPopup: false });
        const order = this.state.allCateringOrdersForBooking.filter(x => x.orderId == orderId)[0];
        if (order.menuItems.length > 0 && order.menuItems[0].menuId)
        {
            const cateringMenu = [...this.state.availableCateringMenus, ...this.state.ordersCateringMenus].filter(menu => menu.Menu_Id == order.menuItems[0].menuId)[0];
            
            const menuView = MenuView.fromApiModel(cateringMenu, order, this.state.bookingData, this.state.orderPolicies, this.userCateringRights);
            this.setState({
                menu: menuView.menu,
                orderItems: menuView.orderItems,
                selectedRestrictions: order.cateringOrderRestrictions,
            });
        }
        else
        {
            this.setState({
                menu: {
                    menuId: this.state.availableCateringMenus.length > 0 ? this.state.availableCateringMenus[0].Menu_Id : '',
                    name: this.state.availableCateringMenus.length > 0 ? this.state.availableCateringMenus[0].Name : '',
                    operationalSettings: this.state.menu.operationalSettings,
                },
                orderItems: this.state.availableCateringMenus.length > 0 ? MenuView.fromApiModel(this.state.availableCateringMenus[0], order, this.state.bookingData, this.state.orderPolicies, this.userCateringRights).orderItems : []
            });
        }

        this.setState({ order: order, originalOrder: order, selectedOrderId: orderId, selectedAllergenRestrictionsFilter: [], selectedDietaryRestrictionsFilter: [], dontShowServiceChangeWarningAgain: false, showServiceTimeChangeWarning: false });
        this.checkMenuItemAvailability(orderId)
    }

    private async addNewOrderSelected(skipUnsavedChangesCheck: boolean): Promise<void>
    {
        if (this.state.unsavedChanges == true && skipUnsavedChangesCheck == false)
        {
            this.setState({ showUnsavedChangesPopup: true, attemptedOrderIdToSelect: '' });
            return;
        }

        const cateringMenu = this.state.availableCateringMenus[0];
        await this.setStateAsync({
            order: new OrderView({
                ...this.state.order,
                menuItems: [],
                cateringServiceTime: DateHelper.fromIsoByNode(this.state.bookingData.Booking_Start, this.state.bookingData.Node_Id),
                cateringClearingTime: DateHelper.fromIsoByNode(this.state.bookingData.Booking_End, this.state.bookingData.Node_Id),
                cateringNotes: '',
                orderId: '',
                isAutomated: false,
                isDisabled: false,
            }),
            selectedRestrictions: [],
            selectedOrderId: '',
            showUnsavedChangesPopup: false,
            unsavedChanges: false
        });
        const menuView = MenuView.fromApiModel(cateringMenu, this.state.order, this.state.bookingData, this.state.orderPolicies, this.userCateringRights);
        this.setState({ menu: menuView.menu, orderItems: menuView.orderItems, });
    }

    private getItemPrice(itemId: string, menuId: string): number 
    {     
        const allMenus = [...this.state.availableCateringMenus, ...this.state.ordersCateringMenus];     
        const matchedMenuItem = allMenus.find(menu => menu.Menu_Id === menuId)?.Menu_MenuItems.find(item => item.MenuItem_Id === itemId);     
        return matchedMenuItem?.MenuItem.RetailPrice || 0; 
    }

    private getOrderCostTotal(items: MenuItemView[]): number
    {
        const orderTotal = items?.map(x => this.getItemPrice(x.id, x.menuId) * x.quantityOfItems).reduce((x, y) => { return x + y }, 0);
        return orderTotal;
    }

    private onAddFurtherOrdersClicked(): void
    {
        this.setState({ showCateringAddedPopup: false });
    }

    private getAllOrdersCostTotals(): string
    {
        let orderTotal = 0;

        this.state.allCateringOrdersForBooking.filter((order) =>
            order.cateringStatus !== CateringOrderStatus.CancellationPending &&
            order.cateringStatus !== CateringOrderStatus.CancelledNoCharge &&
            order.cateringStatus !== CateringOrderStatus.CancelledCharged &&
            !(order.orderId === this.state.order.orderId && this.state.order.isDisabled)
        ).forEach(order =>
        {
            orderTotal = orderTotal + this.getOrderCostTotal(order.menuItems);
        });

        return orderTotal.toFixed(2);
    }

    private getAllOrdersItemTotals(): number
    {
        let itemTotal = 0

        this.state.allCateringOrdersForBooking.filter((order) =>
            order.cateringStatus !== CateringOrderStatus.CancellationPending &&
            order.cateringStatus !== CateringOrderStatus.CancelledNoCharge &&
            order.cateringStatus !== CateringOrderStatus.CancelledCharged &&
            !(order.orderId === this.state.order.orderId && this.state.order.isDisabled)
        ).forEach(order =>
        {
            if (order.menuItems.length > 0)
            {
                itemTotal = itemTotal + order.menuItems?.map(x => x.quantityOfItems).reduce((x, y) => { return x + y })
            }
        });

        return itemTotal;
    }

    private getAllMenusViewForOrder(orderMenuId: string): MenuView[]
    {
        const orderCateringMenuView = this.state.ordersCateringMenus.map(menu => MenuView.fromApiModel(menu, null, this.state.bookingData, this.state.orderPolicies, this.userCateringRights)).filter(menu => menu.menu.menuId === orderMenuId);  

        // if order is automated, only return the menu it was created with.
        if(this.state.order.isAutomated)
        {
            return orderCateringMenuView.filter(order => orderCateringMenuView.find(menuView => order.menu.menuId === menuView.menu.menuId ));
        }

        const allUniqueMenus = [...this.state.availableCateringMenusView, ...orderCateringMenuView.filter(orderMenu => !this.state.availableCateringMenusView.find(menu => menu.menu.menuId === orderMenu.menu.menuId))];
        return allUniqueMenus;
    }

    private createMenuOptionLabel(menu: MenuView): string
    {
        // if menu isn't in list of available menus in current space, change label to menuName (Unavailable);
        if(this.state.availableCateringMenusView.find(availableMenu => availableMenu.menu.menuId === menu.menu.menuId))
        {
            return menu.menu.name;
        }
        else
        {
            return `${menu.menu.name} (${this.labels.HubLabelUnavailable})`;
        }
    }

    private getMenusForDropDown()
    {
        const orderMenuId = this.state.order.menuItems[0]?.menuId ?? '';
        const menus =  this.getAllMenusViewForOrder(orderMenuId).map(menu => ({ label: this.createMenuOptionLabel(menu), value: menu.menu.menuId })).sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
        return menus;
    }

    private get showAddNewOrderWidget(): boolean
    {
        const newOrder = this.state.order.orderId == "";
        return !newOrder && this.hasMultipleOrdersRights && this.state.bookingData.Booking_Status !== "Cancelled" && this.state.bookingData.Booking_Status !== "Auto Cancelled";
    }

    private unsavedChangesContinue(): void
    {
        if (this.state.viewBookingSelected)
        {
            this.onViewBookingClicked(false);
        }
        else
        {
            if (this.state.attemptedOrderIdToSelect == '')
            {
                this.addNewOrderSelected(true);
            }
            else
            {
                this.orderSelected(this.state.attemptedOrderIdToSelect, true);
            }
        }
    }

    private updateOrderClicked(): void
    {
        // show only if state.menu id and order menuItems's menu ids are different. else, set showConfirmationModal to true to show Confirm changes summary modal straight away.
        if(this.state.order.menuItems.some(menuItem => menuItem.quantityOfItems > 0 && menuItem.menuId !== this.state.menu.menuId))
        {
            this.setState({ showConfirmChangesWithMenuPopup: true });
        }
        else
        {
            this.setState({ showConfirmationModal: true });
        }
    }

    private cancelChangesWithNewMenu(): void
    {
        // reset original menu and its orderItems and quantities.
        const menuId = this.state.originalOrder.menuItems[0]?.menuId;
        const originalMenu = this.getAllMenusViewForOrder(menuId).filter(x => x.menu.menuId == menuId)[0];
        const orderItems = originalMenu.orderItems.map(item => ({ ...item, quantity: this.getOrderItemQuantity(item.menuItemId) }));

        this.setState({
            menu: originalMenu.menu,
            orderItems: orderItems,
            unsavedChanges: false,
            showConfirmChangesWithMenuPopup: false,
        });
    }

    private getOrderItemQuantity(menuItemId: string): number
    {
        // check each menu item's id - OrderItems.menuItemId against the state.order.menuItems.id, to get their quantities.
        const orderItemQuantity = this.state.order.menuItems.find(menuItem => menuItem.id === menuItemId)?.quantityOfItems ?? 0;
        return orderItemQuantity;
    }

    private get orderName(): string
    {
        const index = this.state.allCateringOrdersForBooking.findIndex((order) => order.orderId === this.state.selectedOrderId);
        return `${this.labels.funcEditCateringOrder_S} ${index + 1}`;
    }

    private get availableMenuItemIds(): string[]
    {
        //returns the unique id - meunItemId, of all order items on all menus available on current space.
        return this.state.availableCateringMenusView.flatMap(menu => menu.orderItems.map(orderItem => orderItem.menuItemId));
    }

    private handleQuantityChange = (itemId: string, quantity: number): void => 
    {
        this.setItemQuantity(itemId, quantity);
    }

    private handleInputChange = (itemId: string, input: string): void => 
    {
        this.itemQuantityInputChanged(itemId, input);
    }

    private disableAutomatedOrder(disableOrder: boolean): void
    {
        this.setState({ order: new OrderView({...this.state.order, isDisabled: disableOrder})});
    }

    private getCutOffTime(preBookCateringTime: string, bookingStart: DateTime): DateTime
    {
        const cutOffTimeDays = preBookCateringTime.split('.')[0];
        const cutOffTimeOfDay = preBookCateringTime.split('.')[1]?.split(':');

        if(!cutOffTimeDays || !cutOffTimeOfDay)
        {
            return DateHelper.null();
        }

        const cutOffTime = cutOffTimeOfDay && bookingStart.date().plus({ days: -parseInt(cutOffTimeDays) }).set({ hour: parseInt(cutOffTimeOfDay[0]), minute: parseInt(cutOffTimeOfDay[1]) });
        return cutOffTime;
    }

    private getCutoffTimeDuration(cutOffTime: DateTime): string
    {
        return cutOffTime.isValid ? cutOffTime.diff(DateTime.now().offsetTimeByNode(this.buildingId), ['hours', 'minutes']).toFormat('hh:mm') : '';
    }

    private isPastCutoffPeriod(cutOffTime: DateTime): boolean
    {
        return cutOffTime.isValid ? DateTime.now().offsetTimeByNode(this.buildingId) > cutOffTime : false;
    }

    public render(): JSX.Element
    {
        const { match } = this.props;
        const bookingStart = DateHelper.fromIsoByNode(this.state.bookingData.Booking_Start, this.state.bookingData.Node_Id);
        const bookingEnd = DateHelper.fromIsoByNode(this.state.bookingData.Booking_End, this.state.bookingData.Node_Id);

        const gridTaskDetailValues: IGridTaskDetailValues[] =
            [
                {
                    details: this.labels.HubLabelLocation,
                    original: this.state.originalOrder ? this.state.originalOrder.spaceId : '',
                    change: this.state.order ? this.state.order.spaceId : ''
                },
                {
                    details: this.labels.HubLabelServiceTime,
                    original: this.state.originalOrder ? `${this.state.originalOrder.cateringServiceTime.toFormat('HH:mm')}` : '',
                    change: this.state.order ? `${this.state.order.cateringServiceTime.toFormat('HH:mm')}` : '',
                },
                {
                    details: this.labels.HubLabelCleaningTime,
                    original: this.state.originalOrder ? `${this.state.originalOrder.cateringClearingTime.toFormat('HH:mm')}` : '',
                    change: this.state.order ? `${this.state.order.cateringClearingTime.toFormat('HH:mm')}` : '',
                },
                {
                    details: this.labels.HubLabelAttendees,
                    original: this.state.originalOrder ? this.state.originalOrder.cateringAttendees?.toString() : '',
                    change: this.state.order ? this.state.order.cateringAttendees?.toString() : ''
                },
                {
                    details: this.labels.HubLabelCodes,
                    original: this.state.originalOrder ? this.state.originalOrder.costCodeAllocation?.map((x: ICostAllocation) => x.costCode).toString().replaceAll(',', ', ') : '',
                    change: this.state.order ? this.state.costCodes?.map((x: ICostAllocation) => x.costCode).toString().replaceAll(',', ', ') : '',
                },
            ];

        const newOrder = this.state.order.orderId == "";

        const tabs: TabsParameters[] = [
            {
                label: this.labels.funcCateringOrderBeverages_S,
                components: (
                    <IbssCateringItemsAccordion
                        classification="MenuItemClassificationBeverage"
                        order={this.state.order}
                        orderItems={this.state.orderItems}
                        availableMenuItemIds={this.availableMenuItemIds}
                        userCateringRights={this.userCateringRights}
                        currency={this.state.currency}
                        onQuantityChange={this.handleQuantityChange}
                        onInputChange={this.handleInputChange}
                        itemInputType="quantity"
                    />
                )
            },
            {
                label: this.labels.funcCateringOrderSnacks_S,
                components: (
                    <IbssCateringItemsAccordion
                        classification="MenuItemClassificationSnack"
                        order={this.state.order}
                        orderItems={this.state.orderItems}
                        availableMenuItemIds={this.availableMenuItemIds}
                        userCateringRights={this.userCateringRights}
                        currency={this.state.currency}
                        onQuantityChange={this.handleQuantityChange}
                        onInputChange={this.handleInputChange}
                        itemInputType="quantity"
                    />
                )
            },
            {
                label: this.labels.funcCateringOrderFoods_S,
                components: (
                    <IbssCateringItemsAccordion
                        classification="MenuItemClassificationFood"
                        order={this.state.order}
                        orderItems={this.state.orderItems}
                        availableMenuItemIds={this.availableMenuItemIds}
                        userCateringRights={this.userCateringRights}
                        currency={this.state.currency}
                        onQuantityChange={this.handleQuantityChange}
                        onInputChange={this.handleInputChange}
                        itemInputType="quantity"
                    />
                )
            }
        ];

        const allergenRestrictions = this.state.cateringRestrictions.filter(x => x.section == 'Allergen');
        const dietaryRestrictions = this.state.cateringRestrictions.filter(x => x.section == 'Dietary');
        const showStatusUpdateButtons = this.userCateringRights && this.userAPICateringApproveRights;
        const cutOffTime = this.getCutOffTime(this.state.preBookCateringTime, bookingStart);
        const cutOffTimeDuration = this.getCutoffTimeDuration(cutOffTime);
        const pastCutOffPeriod = this.isPastCutoffPeriod(cutOffTime); // whether the current time is past the current menu's cutoffPeriod

        return (
            <>
                {this.state.loading && <LoadingOverlay />}
                <div className="page-height-exct-header">
                    <UnsavedChangesPopup
                        open={this.state.showUnsavedChangesPopup}
                        onClose={() => this.setState({ showUnsavedChangesPopup: false, viewBookingSelected: false })}
                        onCancelClicked={() => this.setState({ showUnsavedChangesPopup: false, viewBookingSelected: false })}
                        onContinueClicked={() => this.unsavedChangesContinue()}
                    />

                    {/* popup that warns the user the consequences of selecting a new menu, but allows them to back out of the choice. */}
                    <ChangeMenuPopup
                        menuId={this.state.newMenuId}
                        open={this.state.showChangeMenuPopup}
                        onClose={() => this.setState({ showChangeMenuPopup: false })}
                        onCancelClicked={() => this.setState({ showChangeMenuPopup: false })}
                        onContinueClicked={() => this.menuChanged(this.state.newMenuId)}
                    />
                    
                    <AlertModal
                        title={this.labels.funcCateringNotAvailable_S}
                        message={this.labels.funcCateringCutoffWarning_L}
                        confirmButtonText={this.labels.HubLabelClose}
                        show={this.state.showChangeMenuPastCutoff}
                        onClose={() => this.setState({ showChangeMenuPastCutoff: false })}
                    />

                    <ConfirmChangesWithMenuPopup 
                        open={this.state.showConfirmChangesWithMenuPopup}
                        onClose={() => this.setState({ showConfirmChangesWithMenuPopup: false })}
                        onCancelClicked={() => this.cancelChangesWithNewMenu()}
                        onContinueClicked={() => this.setState({ showConfirmationModal: true, showConfirmChangesWithMenuPopup: false })}
                    />
                    <ConfirmModal
                        show={this.state.dontShowServiceChangeWarningAgain ? false : this.state.showServiceTimeChangeWarning}
                        modalHeading={this.labels.HubLabelAttention_S}
                        modalMessage={this.labels.funcServiceTimeUpdateWarning_Message}
                        handleModal={() => this.setState({ showServiceTimeChangeWarning: false, dontShowServiceChangeWarningAgain: true })}
                        okButton={() => this.setState({ showServiceTimeChangeWarning: false, dontShowServiceChangeWarningAgain: true })}
                        cancelButtonText={this.labels.HubButtonCancel}
                        confirmButtonText={this.labels.funcProceedServiceTimeChangesButton_S}
                    />
                    <Card style={{ padding: '30px', margin: '25px' }}>
                        <Typography variant="h6" gutterBottom>{this.labels.funcCatering_S}</Typography>
                        <Typography variant="body1" gutterBottom mb={"2"}> 
                            {this.labels.funcCateringOrdersToSpaceBookings_D}
                        </Typography>
                        <div>
                            <div>
                                <BookingDetailsWidget
                                    skeletonLoad={this.state.skeletonLoad}
                                    buildingId={this.buildingId}
                                    spaceName={this.state.bookingData.Space_Name}
                                    spaceImageUrl={this.state.spaces.filter(x => x.Space_Id == this.state.bookingData.Space_Id)[0]?.ImageURI ?? ""}
                                    spaceId={this.state.spaceId}
                                    spaces={this.state.spaces}
                                    start={bookingStart}
                                    end={bookingEnd}
                                    host={this.state.bookingData.Booking_Host_Name}
                                    owner={this.state.bookingData.Booking_Owner_Name}
                                    changeCateringSpace={this.changeCateringSpace}
                                    userHasCateringRights={this.userCateringRights}
                                    newOrder={newOrder}
                                    viewBooking={() => this.onViewBookingClicked(true)}
                                    costCodes={this.state.costCodes}
                                    currency={this.state.currency}
                                    getAllOrdersCostTotals={() => this.getAllOrdersCostTotals()}
                                    getAllOrdersItemTotals={() => this.getAllOrdersItemTotals()}
                                    showCostCodeModal={() => this.setState({ showCostCodeModal: true })}
                                    cutOffTime={cutOffTime}
                                    cutOffTimeDuration={cutOffTimeDuration}
                                    pastCutOffPeriod={pastCutOffPeriod}
                                    userHasIgnoreCateringCutoffRights={this.userIgnoreCateringCutOffRights}
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-wrap mt-3">
                            {
                                this.state.allCateringOrdersForBooking.map((order, index) =>
                                (
                                    <div key={order.orderId} className="mr-3 mb-1" style={{ height: '135px' }} onClick={() => this.orderSelected(order.orderId, false)}>
                                        <OrderSummaryWidget
                                            orderName={`${this.labels.funcEditCateringOrder_S} ` + (index + 1)}
                                            status={order.cateringStatus}
                                            start={order.cateringServiceTime}
                                            end={order.cateringClearingTime}
                                            itemTotal={order.menuItems.length == 0 ? 0 : order.menuItems?.map(x => x.quantityOfItems).reduce((x, y) => { return x + y })}
                                            costTotal={this.getOrderCostTotal(order.menuItems)}
                                            hasUnsavedChanges={this.state.unsavedChanges && this.state.selectedOrderId == order.orderId}
                                            selected={this.state.selectedOrderId == order.orderId}
                                            currency={this.state.currency}
                                            hasUnavailableMenu={this.cateringOrderHasUnavailableMenu(order.orderId)}
                                            orderIsAutomated={this.state.order.isAutomated}
                                            orderIsDisabled={this.state.order.isDisabled}
                                        />
                                    </div>
                                )
                                )
                            }
                            {
                                this.showAddNewOrderWidget &&
                                <div style={{ height: '135px', width: '385px' }}>
                                    <AddNewOrderWidget onClick={() => this.addNewOrderSelected(false)} />
                                </div>
                            }
                        </div>
                    </Card>
                    {
                        showStatusUpdateButtons &&
                        <UpdateCateringStatusButtons
                            cateringOrderStatus={this.state.order.cateringStatus}
                            pastCutOffPeriod={pastCutOffPeriod}
                            onStatusChangeButtonClicked={(status: string) => this.setState({ showStatusUpdateConfirmation: status })}
                            hasApproveRights={this.userAPICateringApproveRights}
                        />
                    }
                    <div className="rightPanel-main-content">
                        <Grid container spacing={2}>
                            <Grid item md={5} xl={4}>
                                <OrderSummaryPanel
                                    bookingName={this.state.order.bookingName}
                                    bookingStart={bookingStart}
                                    bookingEnd={bookingEnd}
                                    orderName={this.orderName}
                                    preBookCateringTime={this.state.preBookCateringTime}
                                    buildingId={this.buildingId}
                                    cateringServiceTime={this.state.order.cateringServiceTime}
                                    cateringClearingTime={this.state.order.cateringClearingTime}
                                    skeletonLoad={this.state.skeletonLoad}
                                    newOrder={newOrder}
                                    cateringStatus={this.state.order.cateringStatus}
                                    onCateringServiceTimeChange={(value) => this.handleChangeCateringServiceTime(value)}
                                    onCateringClearingTimeChange={(value) => this.handleChangeCateringClearingTime(value)}
                                    onNotesChange={(value) => this.setState({ order: new OrderView({ ...this.state.order, cateringNotes: value }), unsavedChanges: true })}
                                    hasUnavailableMenu={this.cateringOrderHasUnavailableMenu(this.state.order.orderId)}
                                    cateringNotes={this.state.order.cateringNotes}
                                    orderItems={this.state.orderItems}
                                    currency={this.state.currency}
                                    displayRestrictionsModal={() => this.displayRestrictionsModal()}
                                    selectedRestrictions={this.state.selectedRestrictions}
                                    cateringRestrictions={this.state.cateringRestrictions}
                                    createClicked={() => this.create()}
                                    cancelChangesClicked={() => this.cancelChanges()}
                                    cancelOrderClicked={() => this.updateOrderStatus(CateringOrderStatus.CancellationPending)}
                                    updateClicked={() => this.updateOrderClicked()}
                                    availableMenuItemIds={this.availableMenuItemIds}
                                    availableMenus={this.getMenusForDropDown()}
                                    selectMenu={(menuId) => this.selectMenu(menuId)}
                                    selectedMenu={this.state.menu.menuId}
                                    pastCutOffPeriod={pastCutOffPeriod}
                                    userHasCateringRights={this.userCateringRights}
                                    userHasIgnoreCateringCutoffRights={this.userIgnoreCateringCutOffRights}
                                    userCateringCancelRights={this.userCateringCancelRights}
                                    serviceTimePickerOpened={() => this.setState({ showServiceTimeChangeWarning: true })}
                                    serviceTimePickerInFocus={() => this.setState({ showServiceTimeChangeWarning: true })}
                                    allOrderedItemsAvailable={this.state.allOrderedItemsAvailable}
                                    orderIsAutomated={this.state.order.isAutomated}
                                    orderIsDisabled={this.state.order.isDisabled}
                                    disableAutomatedOrder={(disableOrder)=> this.disableAutomatedOrder(disableOrder)}
                                />
                            </Grid>
                            <Grid item md={7} xl={8}>
                                <Card sx={{ padding: 1 }} className="mb-3">
                                    <IbssButton variant="contained" onClick={() => this.displayFilterModal()} >{this.labels.HubLabelFilter}</IbssButton>
                                </Card>
                                {
                                    this.state.skeletonLoad ?
                                        <div>
                                            <Card sx={{ height: '124px', marginBottom: '10px', marginTop: '10px' }}><MenuItemSkeleton /></Card>
                                            <Card sx={{ height: '124px' }}><MenuItemSkeleton /></Card>
                                        </div> :
                                        this.state.menu.menuId == '' ?
                                            <Card sx={{ height: '100%' }}>
                                                <div style={{ position: 'relative', top: '15%', textAlign: 'center' }}>
                                                    <img height={300} width={300} src={`/images/NoCateringMenuAvailable.svg`} alt="" />
                                                    <Typography className="mb-1" variant="h5">{this.labels.funcCateringOrderNoMenuAvailable_S}</Typography>
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <div style={{ width: '350px' }}>{this.labels.funcCateringOrderNoMenuAvailable_Message}</div>
                                                    </div>
                                                </div>
                                            </Card>
                                            :
                                            <IbssHorizontalTabs
                                                sx={{ backgroundColor: 'var(--ui-background-alternate)' }}
                                                tabs={tabs}
                                                orientation="horizontal"
                                                boxwidth='100%'
                                            />
                                }
                            </Grid>
                            <Modal show={this.state.showConfirmationModal} onHide={() => this.setState({ showConfirmationModal: false })}>
                                <Modal.Header>
                                    <Modal.Title>{this.labels.HubLabelTaskId}: {this.state.order?.orderId}</Modal.Title>
                                    <button type="button" className="close" onClick={() => this.setState({ showConfirmationModal: false })} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </Modal.Header>
                                <div className='m-4'>
                                    {this.labels.HubLabelEditCateringTaskModalSubtext}
                                </div>
                                {/* Task details */}
                                <Grid container item spacing={2} p={4}>
                                    <Grid item xs={4}>
                                        {this.labels.HubLabelDetailslabel}
                                    </Grid>
                                    <Grid item xs={4}>
                                        {this.labels.HubLabelOriginal}
                                    </Grid>
                                    <Grid item xs={4}>
                                        {this.labels.HublabelChange}
                                    </Grid>
                                    {gridTaskDetailValues.map(x =>
                                    {
                                        return (
                                            <Grid container key={x.details} item spacing={2}>
                                                <Grid item xs={4}>
                                                    {x.details}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {x.original}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {x.change}
                                                </Grid>
                                            </Grid>
                                        )
                                    })}
                                    <Grid item xs={12}>
                                        <hr />
                                    </Grid>
                                    <Box>
                                        <Grid container spacing={2} pl={2}>
                                            <Grid item xs={3}>
                                                {this.labels.HubLabelSection}
                                            </Grid>
                                            <Grid item xs={5}>
                                                {this.labels.HubLabelItem}
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.labels.HubLabelQty}
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.labels.HubLabelCost}
                                            </Grid>

                                            {this.state.orderItems.map((x) =>
                                            {
                                                if (x.quantity > 0)
                                                {
                                                    return (
                                                        <Grid container item key={x.menuItemId} spacing={2} pl={2}>
                                                            <Grid item xs={3}>
                                                                <Typography variant="body1">
                                                                    {this.getClassificationLabel(x.classification)}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <Typography variant="body1">
                                                                    {x.name}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Typography variant="body1">
                                                                    {x.quantity}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Typography variant="body1">
                                                                    {this.state.currency}
                                                                    {(x.retailPrice * x.quantity).toFixed(2)}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    );
                                                }
                                            })}
                                        </Grid>
                                    </Box>
                                </Grid>
                                {/* Order details */}
                                <Modal.Footer>
                                    <div style={{ textAlign: 'center' }}>
                                        <IbssButton
                                            style={{ height: '45px', minWidth: '100px' }}
                                            color='error'
                                            variant="contained"
                                            onClick={() => this.updateOrderAndCateringMenus()}
                                        >
                                            {this.labels.HubButtonSave}
                                        </IbssButton>
                                    </div>
                                </Modal.Footer>
                            </Modal>
                            {/* -----------------------------Start Restrictions Popup---------------------------*/}
                            <IbssDialog
                                open={this.state.showRestrictionsModal}
                                onClose={() => this.closeRestrictionsModal()}
                                dialogContent=
                                {
                                    <>
                                        <div className="mb-3">{this.labels.funcCateringOrderAllergens_D}</div>
                                        <Divider />
                                        <div className="mb-2 mt-1">{this.labels.funcCateringOrderRemoveFoods_M}:</div>
                                        <div className="mb-3" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {allergenRestrictions.map(restriction => (<IbssCheckBox checked={this.state.selectedRestrictionsEdit.map(x => x.id).includes(restriction.id)} label={restriction.name} onClicked={(e: { target: { checked: boolean } }) => this.restrictionCheckboxSelected(e.target.checked, restriction)} />))}
                                        </div>
                                        <div style={{ textAlign: 'right' }}>
                                            <IbssButton variant="contained" onClick={() => this.applyRestrictionUpdated()}>{this.labels.HubButtonSave}</IbssButton>
                                        </div>
                                    </>
                                }
                                header={this.labels.funcCateringOrderAllergyInformation_S}
                                fullWidth
                            />
                            {/* -----------------------------End Restrictions Popup---------------------------*/}

                            {/* -----------------------------Start Filter Popup---------------------------*/}
                            <IbssDialog
                                open={this.state.showFilterModal}
                                onClose={() => this.closeFilterModal()}
                                dialogContent=
                                {
                                    <>
                                        <div className="mb-3">{this.labels.funcCateringOrderFilter_Message}</div>
                                        <Divider />
                                        <div className="mb-2 mt-1">{this.labels.funcCateringOrderRemoveFoods_M}:</div>
                                        <div className="mb-3" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {allergenRestrictions.map(restriction => (<IbssCheckBox checked={this.state.selectedAllergenRestrictionsFilterEdit.includes(restriction.name)} label={restriction.name} onClicked={(e: { target: { checked: boolean } }) => this.allergenFilterCheckboxSelected(e.target.checked, restriction.name)} />))}
                                        </div>
                                        <Divider />
                                        <div className="mb-2 mt-1">{this.labels.funcCateringOrderOnlyShowMarkedFoods_M}:</div>
                                        <div className="mb-3" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {dietaryRestrictions.map(restriction => (<IbssCheckBox checked={this.state.selectedDietaryRestrictionsFilterEdit.includes(restriction.name)} label={restriction.name} onClicked={(e: { target: { checked: boolean } }) => this.dietaryFilterCheckboxSelected(e.target.checked, restriction.name)} />))}
                                        </div>
                                        <div style={{ textAlign: 'right' }}>
                                            <IbssButton variant="contained" onClick={() => this.applyRestrictionFilterUpdated()}>{this.labels.funcCateringOrderApply_S}</IbssButton>
                                        </div>
                                    </>
                                }
                                header={this.labels.funcCateringOrderFilterBy_S}
                                fullWidth
                            />
                            {/* -----------------------------End Filter Popup---------------------------*/}

                            {/* -----------------------------Start Cost codes Popup---------------------------*/}
                            <CostCodesDialog
                                buildingId={this.buildingId}
                                selectedCostCodes={this.state.costCodes}
                                show={this.state.showCostCodeModal}
                                onClose={() => this.handleCostCodeModal()}
                                updateBookingCostCodes={(updatedCostCodes) => this.updateBookingCostCodes(updatedCostCodes)}
                            />
                            {/* -----------------------------End Cost codes Popup---------------------------*/}

                            {/* Start Change Space Remove Items popup */}
                            <ConfirmModal
                                show={this.state.showRemoveItemsFromUnavailableMenuModal}
                                name=''
                                modalHeading={this.labels.HubLabelWarning}
                                modalMessage={this.labels.funcCateringOrderItemInUnavailableMenu_D}
                                handleModal={()=> this.setState({showRemoveItemsFromUnavailableMenuModal: false})}
                                okButton={()=> this.closeItemsFromUnavailableMenuModal()}
                            />
                            {/* End Change Space Remove Items popup */}
                        </Grid>
                        <Modal show={this.state.showStatusUpdateConfirmation != ''} onHide={() => this.setState({ showStatusUpdateConfirmation: '' })}>
                            <Modal.Header>
                                <Modal.Title>{this.labels.HubLabelModalConfirmTitle}</Modal.Title>
                                <button type="button" className="close" onClick={() => this.setState({ showStatusUpdateConfirmation: '' })} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </Modal.Header>
                            <div className='m-4'>
                                {this.labels.funcCateringOrderStausUpdate_Message}
                            </div>
                            <Modal.Footer>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                                    <IbssButton
                                        style={{ height: '45px', minWidth: '100px' }}
                                        color='secondary'
                                        variant="contained"
                                        onClick={() => this.setState({ showStatusUpdateConfirmation: '' })}
                                    >
                                        {this.labels.HubButtonCancel}
                                    </IbssButton>
                                    <IbssButton
                                        style={{ height: '45px', minWidth: '100px' }}
                                        color='primary'
                                        variant="contained"
                                        onClick={() => this.updateOrderStatus(this.state.showStatusUpdateConfirmation)}
                                    >
                                        {this.labels.HubLabelOk}
                                    </IbssButton>
                                </div>
                            </Modal.Footer>
                        </Modal>
                        {/* CATERING ADDED MODAL */}
                        <IbssDialog
                            aria-modal="true"
                            aria-label="equipment modal"
                            open={this.state.showCateringAddedPopup}
                            fullWidth
                            dialogContent=
                            {
                                <div className='d-flex justify-content-between'>
                                    <Box sx={{ flex: 1 }}>
                                        <div className="d-flex justify-content-center">
                                            <div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <IbssSvgIcon sx={{ marginLeft: '-22px' }} className="font-18">{Icons.Success}</IbssSvgIcon>
                                                </div>
                                                <p style={{ paddingTop: "5px" }}>{this.labels.funcCateringAdded_S}!</p>
                                            </div>
                                        </div>
                                    </Box>
                                </div>
                            }
                            footer=
                            {
                                <div className='d-flex w-90' style={{ justifyContent: 'space-between' }}>
                                    <IbssButton
                                        variant="contained"
                                        color='secondary'
                                        onClick={() => this.onViewBookingClicked(true)}
                                    >
                                        {this.labels.funcViewBooking_S}
                                    </IbssButton>
                                    <div>
                                        <IbssButton
                                            variant="contained"
                                            color='secondary'
                                            className="mr-2"
                                            onClick={() => this.onReturnHomeClicked()}
                                        >
                                            {this.labels.funcCreateBookingReturnHome_S}
                                        </IbssButton>
                                        {
                                            this.hasMultipleOrdersRights &&
                                            <IbssButton
                                                variant="contained"
                                                onClick={() => this.onAddFurtherOrdersClicked()}
                                            >
                                                {this.labels.funcEditCateringOrderAdd_L}
                                            </IbssButton>
                                        }
                                    </div>
                                </div>
                            }
                            onClose={() => this.onReturnHomeClicked()}
                        />
                    </div>
                </div>
            </>
        );
    }

}

export class MenuItemSkeleton extends Component
{
    public render(): JSX.Element
    {
        return (
            <div style={{ display: 'flex', padding: '10px' }}>
                <Skeleton variant="rectangular" width={100} height={100} />
                <div style={{ width: '100%' }}>
                    <Skeleton sx={{ margin: '15px', marginBottom: '10px' }} variant="rectangular" width={'70%'} height={10} />
                    <Skeleton sx={{ margin: '15px' }} variant="rectangular" width={'50%'} height={10} />
                </div>
            </div>
        )
    }
}

export interface IProps extends RouteComponentProps<IQueryParams, StaticContext, IRouteState>
{
}

export interface IQueryParams
{
    bookingid: string;
    buildingid: string;
    cateringOrderId: string;
    spaceId: string;
}

export interface IRouteState
{
    bookingId?: string;
    originRoute?: string;
}

export interface IState
{
    order: OrderView;
    originalOrder: OrderView;
    allCateringOrdersForBooking: OrderView[];
    selectedOrderId: string;
    orderItems: CateringMenuItemView[];
    loading: boolean;
    currency: string;
    preBookCateringTime: string;
    showConfirmationModal: boolean;
    floorId: number;
    spaceId: string;
    currentUsersRoleIds: string[];
    numOfAttendees: number;
    spaces: Space[];
    showCostCodeModal: boolean;
    lightModeTheme: boolean;
    costCodes: CostCodeWithAllocation[];
    menu: ICateringMenuView;
    newMenuId: string;
    cateringRestrictions: ICateringRestrictionView[];
    selectedRestrictions: ICateringRestrictionView[];
    selectedRestrictionsEdit: ICateringRestrictionView[];
    showRestrictionsModal: boolean;
    selectedAllergenRestrictionsFilter: string[],
    selectedAllergenRestrictionsFilterEdit: string[],
    selectedDietaryRestrictionsFilter: string[],
    selectedDietaryRestrictionsFilterEdit: string[],
    showFilterModal: boolean,
    showRemoveItemsFromUnavailableMenuModal: boolean,
    itemOrderPolicies: ICateringOrderPolicyView[],
    skeletonLoad: boolean,
    showStatusUpdateConfirmation: string,
    resetCateringStatus: boolean,
    availableCateringMenusView: MenuView[],
    showCateringAddedPopup: boolean,
    bookingData: IGetV2BookingResponse,
    orderPolicies: ICateringOrderPolicy[],
    availableCateringMenus: ICateringMenu[],
    ordersCateringMenus: ICateringMenuExpanded[], // catering menus currently used by orders. 
    unsavedChanges: boolean,
    showUnsavedChangesPopup: boolean,
    showChangeMenuPopup: boolean,
    showChangeMenuPastCutoff: boolean,
    showConfirmChangesWithMenuPopup: boolean,
    attemptedOrderIdToSelect: string,
    viewBookingSelected: boolean,
    showServiceTimeChangeWarning: boolean,
    dontShowServiceChangeWarningAgain: boolean,
    allOrderedItemsAvailable: boolean,
    buildingAlwaysApproveCateringOrders: number
}

export class OrderView
{
    public orderId = "";
    public nodeId = 0;
    public menuItems = new Array<MenuItemView>();
    public cateringServiceTime = DateHelper.null();
    public cateringClearingTime = DateHelper.null();
    public cateringStatus = "";
    public cateringAttendees = "";
    public cateringNotes = "";
    public costCodeAllocation: ICostAllocation[] = [];
    public cateringOrderRestrictions = [];
    public bookingName = "";
    public bookingId = "";
    public spaceName = "";
    public spaceId = "";
    public menuId = "";
    public isAutomated = false;
    public isDisabled = false;

    constructor(value?: Partial<OrderView>)
    {
        if (value == null)
        {
            return;
        }
        Object.assign(this, value);
    }
    
    public static fromApiTask(data: CateringOrder): OrderView
    {
        return new OrderView(
            {
                orderId: data.Order_Id,
                nodeId: data.Node_Id,
                menuItems: JSON.parse(data.Menu_Items).map((i: IMenuItem) => MenuItemView.fromApiModel(i)),
                cateringServiceTime: DateHelper.fromIsoByNode(data.Catering_Service_Time, data.Node_Id),
                cateringClearingTime: DateHelper.fromIsoByNode(data.Catering_Clearing_Time, data.Node_Id),
                cateringStatus: data.Catering_Order_Status,
                cateringAttendees: data.Catering_Attendees,
                cateringNotes: data.Catering_Notes,
                costCodeAllocation: Helper.parseJsonArray<{ Cost_Code: string; Cost_Code_Id: string; Allocation: number }>(data.Cost_Code_Allocation).map((x: { Cost_Code: string; Cost_Code_Id: string; Allocation: number }) => ({ costCode: x.Cost_Code, costCodeId: x.Cost_Code_Id, allocation: x.Allocation, costCodeDescription: '' })),
                cateringOrderRestrictions: data.Catering_Order_Restrictions.length > 0 ? JSON.parse(data.Catering_Order_Restrictions) : [],
                bookingName: data.Booking_Name,
                bookingId: data.Booking_Id,
                spaceName: data.Space_Name,
                spaceId: data.Space_Id,
                menuId: data.Menu_Id,
                isAutomated: !!data.IsAutomated,
                isDisabled: !!data.IsDisabled,
            });
    }

    public toApiOrder(spaceId: string, bookingId: string, nodeId: number, numOfAttendees: number, orderItems: string, costCodeAllocations: ICostCodeAllocation[], orderTotal: number, restrictions: ICateringRestrictionView[], cateringOrderStatus: string, cateringServiceTime: string, cateringClearingTime: string, cateringCutoffTime?: string): ICreateCateringOrder
    {
        const payload: ICreateCateringOrder =
        {
            Node_Id: nodeId,
            Menu_Items: orderItems,
            Booking_Id: bookingId,
            Space_Id: spaceId,
            Catering_Service_Time: cateringServiceTime,
            Catering_Clearing_Time: cateringClearingTime,
            Catering_Order_Status: cateringOrderStatus,
            Catering_Attendees: numOfAttendees,
            Catering_Notes: this.cateringNotes,
            Cost_Code_Allocation: JSON.stringify(costCodeAllocations),
            Catering_Total_Value: orderTotal,
            Catering_Order_Restrictions: JSON.stringify(restrictions),
            Catering_Cutoff_Time : cateringCutoffTime
        };

        return payload;
    }
}

export class MenuItemView
{
    public id = "";
    public menuId = "";
    public quantityOfItems = 0;

    public static fromApiModel(data: IMenuItem): MenuItemView
    {
        return {
            id: data.Id,
            menuId: data.Menu_Id,
            quantityOfItems: data.QuantityOfItems,
        };
    }
}

export class MenuView
{
    public menu = {
        menuId: '',
        name: '',
        operationalSettings: EmptyOperationalSettings
    };
    public orderItems: CateringMenuItemView[] = [];

    public static itemAvailableToOrder(bookingData: IGetV2BookingResponse, menuItem: IMenuItems, orderPolicy: ICateringOrderPolicy[], order: OrderView | null): boolean
    {
        const itemPolicy = orderPolicy.filter(policy => policy.OrderPolicy_Id == menuItem.MenuItem.OrderPolicy_Id)[0];

        let availableToOrder = true;
        if (itemPolicy && order?.cateringServiceTime)
        {
            const prepCompletionTime = DateTime.now().plus({ minutes: itemPolicy.PreparationTime_Mins });
            const kitchenOpenWithinServiceTime = parseInt(order.cateringServiceTime.toFormat('HH:mm').replace(':', '')) >= parseInt(itemPolicy.Kitchen_OperatingHours_Start.replace(':', '')) && parseInt(order.cateringServiceTime.toFormat('HH:mm').replace(':', '')) <= parseInt(itemPolicy.Kitchen_OperatingHours_Stop.replace(':', ''));

            if (prepCompletionTime > DateTime.fromISO(bookingData.Booking_Start) || !kitchenOpenWithinServiceTime)
            {
                availableToOrder = false;
            }
        }
        return availableToOrder;
    }

    public static fromApiModel(cateringMenu: ICateringMenu, order: OrderView | null, bookingData: IGetV2BookingResponse, orderPolicy: ICateringOrderPolicy[], userHasCateringRights: boolean): MenuView
    {
        let operationalSettings: IOperationalSettings = EmptyOperationalSettings;

        try
        {
            if(cateringMenu?.OperationalSettings)
            {
                operationalSettings = JSON.parse(cateringMenu.OperationalSettings) as unknown as IOperationalSettings;
            }
        }
        catch {}

        return {
            menu: {
                menuId: cateringMenu.Menu_Id,
                name: cateringMenu.Name,
                operationalSettings: operationalSettings,
            },
            orderItems: cateringMenu.Menu_MenuItems.map(menuItem =>
            {
                const item = (order == null ? null : order.menuItems.filter(i => i.id == menuItem.MenuItem_Id)[0]);
                const availableToOrderByPolicy =  this.itemAvailableToOrder(bookingData, menuItem, orderPolicy, order); // determine whether this item is available to order given order policy, regardless of catering rights?
                const availableToOrder = userHasCateringRights || availableToOrderByPolicy;
                const orderIsAutomated = order?.isAutomated ?? false;

                return ({
                    description: menuItem.MenuItem.Description,
                    status: menuItem.MenuItem.Status,
                    unitPrice: menuItem.MenuItem.UnitPrice,
                    classification: menuItem.MenuItem.Classification,
                    retailPrice: menuItem.MenuItem.RetailPrice,
                    name: menuItem.MenuItem.Name,
                    supplierId: menuItem.MenuItem.Supplier_Id,
                    menuItemId: menuItem.MenuItem_Id,
                    nutritionalInformation: menuItem.MenuItem.NutritionalInformation,
                    orderPolicy_Id: menuItem.MenuItem.OrderPolicy_Id,
                    imageURI: menuItem.MenuItem.ImageURI,
                    quantity: item?.quantityOfItems ?? 0,
                    meetsFilterRequirements: true,
                    availableToOrder: availableToOrder,
                    availableToOrderByPolicy: availableToOrderByPolicy,
                    showMenuItem: orderIsAutomated || true,

                    menuItemRestrictions: menuItem.MenuItem.MenuItem_Restrictions.map(x => ({
                        id: x.Restriction_Id || '',
                        section: x.Restriction.Section,
                        imageURI: x.Restriction.ImageURI,
                        name: x.Restriction.Name
                    }))
                })
            }),
        };
    }
}

export interface ICostAllocation
{
    costCode: string;
    costCodeId: string;
    allocation: number;
    costCodeDescription: string;
}

class CostAllocationView
{
    public costCode: string;
    public costCodeId: string;
    public allocation: number;
    public costCodeDescription: string;

    public constructor()
    {
        this.costCode = '';
        this.costCodeId = '';
        this.allocation = 0;
        this.costCodeDescription = '';
    }

    public static fromUserPrefDefaultCateringCostCodes(cateringCostCode: IDefaultCostCodes): ICostAllocation
    {
        return {
            costCode: cateringCostCode.CostCodeName,
            costCodeId: cateringCostCode.CostCodeID,
            allocation: parseInt(cateringCostCode.CostCodeApportionment),
            costCodeDescription: cateringCostCode.CostCodeDescription,
        }
    }

    public static fromBookingCateringCostCodes(bookingCostCode: ICostCodeAllocation): ICostAllocation
    {
        return {
            costCode: bookingCostCode.Cost_Code,
            costCodeId: bookingCostCode.Cost_Code_Id,
            allocation: bookingCostCode.Allocation,
            costCodeDescription: '',
        }
    }
}

export interface IGridTaskDetailValues
{
    details: string;
    original: string;
    change: string;
}

export interface CateringMenuItemView
{
    description: string;
    status: Status;
    unitPrice: number;
    classification: Classification;
    retailPrice: number;
    name: string;
    supplierId: string;
    menuItemId: string;
    nutritionalInformation: string;
    orderPolicy_Id: string;
    imageURI: string;
    quantity: number;
    availableToOrder: boolean;
    availableToOrderByPolicy: boolean;
    menuItemRestrictions: ICateringRestrictionView[];
    meetsFilterRequirements: boolean;
    showMenuItem: boolean;
}

export interface ICateringRestrictionView
{
    id: string;
    section: string;
    imageURI: string;
    name: string;
}

export interface ICateringMenuView
{
    menuId: string;
    name: string;
    operationalSettings: IOperationalSettings;
}

export interface ICateringOrderPolicyView
{
    policyId: string;
    advancedNotice: string;
    preperationTimeMins: number;
    kitchenHoursStart: string;
    kitchenHoursStop: string;
}